"use client";
import {
  useTabStore
} from "../__chunks/PY4NZ6HS.js";
import "../__chunks/VEVQD5MH.js";
import "../__chunks/KPEX55MY.js";
import {
  TabContextProvider
} from "../__chunks/UYGDZTLQ.js";
import "../__chunks/4CMBR7SL.js";
import "../__chunks/C3IKGW5T.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/MTZPJQMC.js";
import "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import "../__chunks/LMDWO4NN.js";
import "../__chunks/YV4JVR4I.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/tab/tab-provider.tsx
import { jsx } from "react/jsx-runtime";
function TabProvider(props = {}) {
  const store = useTabStore(props);
  return /* @__PURE__ */ jsx(TabContextProvider, { value: store, children: props.children });
}
export {
  TabProvider
};
